// extracted by mini-css-extract-plugin
export default {"loader":"loader__xVXJeo532kKo","ConversationList_listContainer_desktop":"ConversationList_listContainer_desktop__GAl0CgnLIJsS"};